import { PaymentOption } from '@navio/nsdk';
import { NoddiIcon, NoddiIconName } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';

const PAYMENT_OPTION_ICON: Record<PaymentOption, NoddiIconName> = {
  [PaymentOption.PAY_BEFORE]: 'CreditCard',
  [PaymentOption.PAY_AFTER]: 'Clock',
  [PaymentOption.INVOICE]: 'FileText'
};

const PAYMENT_OPTION_SHORT_LABELS: Record<PaymentOption, string> = {
  [PaymentOption.PAY_BEFORE]: 'Pay before',
  [PaymentOption.PAY_AFTER]: 'Pay after',
  [PaymentOption.INVOICE]: 'Invoice'
};

type Props = {
  paymentOption: PaymentOption;
};

export const PaymentOptionLabel = ({ paymentOption }: Props) => {
  return (
    <NoddiBadge variant='outline'>
      <NoddiIcon name={PAYMENT_OPTION_ICON[paymentOption]} size='small' />
      {PAYMENT_OPTION_SHORT_LABELS[paymentOption]}
    </NoddiBadge>
  );
};

export { PAYMENT_OPTION_ICON, PAYMENT_OPTION_SHORT_LABELS };
